<template>
    <div class="hundred_percent_form" v-loading="loading">
        <el-form :model="form" ref="form" label-width="100px" class="demo-ruleForm">
            <el-form-item label="标题" prop="configsname" :rules="filter_rules({ required: true })">
                <el-input v-model="form.configsname"></el-input>
            </el-form-item>
            <el-form-item label="内容" prop="configstext" :rules="filter_rules({ required: true })">
                <tinymce style="display: inline-block;width: 100%;" ref="tinymce" :height="500"
                    v-model="form.configstext" />
            </el-form-item>
            <el-form-item>
                <div style="margin-top:20px">
                    <el-button type="primary" @click="formSubmit">保 存</el-button>
                </div>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import {
        userAgreement,
        edittreaty
    } from "../../api/setting/text.js";
    import Tinymce from "../../components/Tinymce/index.vue";
    export default {
        data() {
            return {
                loading: false,
                formLoading: false,
                form: {
                    configsname: "",
                    configsid: "",
                    configstext: "",
                    configstype: 6
                }
            };
        },
        components: {
            Tinymce
        },
        methods: {
            getInfo() {
                this.loading = true;
                userAgreement({
                        configstype: this.form.configstype
                    })
                    .then(response => {
                        this.loading = false;
                        if (response.code) {
                            this.$message.error(response.message);
                        }
                        if (response.data) {
                            this.form = response.data;
                            this.$refs.tinymce.setContent(this.form.configstext);
                        }
                        setTimeout(() => {}, 0.3 * 1000);
                    })
                    .catch(() => {});
            },
            formSubmit() {
                this.formLoading = true;
                let data = Object.assign({}, this.form);
                edittreaty(data).then(response => {
                    this.formLoading = false;
                    if (response.code) {
                        this.$message.error(response.message);
                        this.formLoading = false;
                        return false;
                    }
                    this.$message.success("操作成功");
                    //刷新表单
                    this.getInfo();
                });
            }
        },
        created() {
            this.getInfo();
        }
    };

</script>

<style type="text/scss" lang="scss">
    body {
  margin: 0;
}
</style>
